import { FormSchema } from '../../../components/FormRenderer/types';

export const schoolStructureSchema: FormSchema = [
  {
    name: 'houses',
    label: 'School Houses',
    type: 'multi-value-input',
    placeholder: 'Enter house name and press enter to add.',
    gridProps: { xs: 12, sm: 12 }
  },
  {
    name: 'sections',
    label: 'Sections',
    type: 'array',
    itemTemplate: {
      grades: []
    },
    children: [
      {
        name: 'name',
        label: 'Section Name',
        type: 'input'
      },
      {
        name: 'grades',
        label: 'Grades',
        type: 'array',
        itemTemplate: {
          name: '',
          displayName: '',
          divisions: [],
          board: ''
        },
        children: [
          {
            name: 'name',
            label: 'Grade Name',
            type: 'input'
          },
          {
            name: 'displayName',
            label: 'Display Name',
            type: 'input'
          },
          {
            name: 'divisions',
            label: 'Divisions',
            type: 'multi-value-input',
            placeholder: 'Type division and press Enter'
          },
          {
            name: 'board',
            label: 'Board',
            type: 'input'
          }
        ]
      }
    ]
  }
];
